/**
 * Compact labelled stat tile used by the dashboard detail renderers. Shared so
 * each migrated tool's registry component reuses one definition (the legacy
 * copy in ToolDetailPanel is removed once its last consumer migrates).
 */
export function MiniStat({
  label,
  value,
  color,
}: {
  label: string
  value: number | string
  color?: string
}) {
  return (
    <div className='rounded-lg border border-border bg-background p-2.5 text-center'>
      <p
        className='text-lg font-black'
        style={{ color: color || 'var(--foreground)' }}
      >
        {value}
      </p>
      <p className='text-xs text-muted-foreground'>{label}</p>
    </div>
  )
}
